/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Start_Trial_ButtonInputs */

const en_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start 7-Day Free Trial`)
};

const fr_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer l'Essai Gratuit de 7 Jours`)
};

const de_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 Tage kostenlos testen`)
};

const it_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia la prova gratuita di 7 giorni`)
};

const ru_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните 7-дневную бесплатную пробную версию`)
};

const es_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comience una prueba gratuita de 7 días`)
};

const zh_cn2_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始7天免费试用`)
};

const ja_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7日間無料トライアルを開始`)
};

const hi_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 दिन का निःशुल्क परीक्षण शुरू करें`)
};

const pt_pt2_signup_start_trial_button = /** @type {(inputs: Signup_Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece seu teste gratuito de 7 dias`)
};

/**
* | output |
* | --- |
* | "Start 7-Day Free Trial" |
*
* @param {Signup_Start_Trial_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_start_trial_button = /** @type {((inputs?: Signup_Start_Trial_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Start_Trial_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_start_trial_button(inputs)
	if (locale === "de") return de_signup_start_trial_button(inputs)
	if (locale === "it") return it_signup_start_trial_button(inputs)
	if (locale === "ru") return ru_signup_start_trial_button(inputs)
	if (locale === "es") return es_signup_start_trial_button(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_start_trial_button(inputs)
	if (locale === "ja") return ja_signup_start_trial_button(inputs)
	if (locale === "hi") return hi_signup_start_trial_button(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_start_trial_button(inputs)
	return en_signup_start_trial_button(inputs)
});